/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetDocumentResponse } from '../../models/get-document-response';

export interface GetCookiePolicy$Params {
}

export function getCookiePolicy(http: HttpClient, rootUrl: string, params?: GetCookiePolicy$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDocumentResponse>> {
  const rb = new RequestBuilder(rootUrl, getCookiePolicy.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetDocumentResponse>;
    })
  );
}

getCookiePolicy.PATH = '/api/documents/cookie-policy';
